module.exports = "query subscriptionCredits($userId:ID!){subscriptionCredits(userId:$userId)}"